import { useEffect, useState } from "react";
import FullLoader from "components/loader/full-loader";
import { useAuth } from "hooks/useAuth";
import ProfileLayout from "./profile-layout";
// import { useFormChangeHandler } from "hooks/useFormChangeHandler";
import { useSubmitHandler } from "hooks/useSubmitHandler";
import { useCanvasHandler } from "hooks/useCanvasHandler";
// import { patchRequest } from "services/api";
import { useUpdateData } from "hooks/useApiHooks";

const ProfilePage = () => {
  const { user, loading } = useAuth();
  const API_URL = "/me";
  console.log("ProfilePage user", user);
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    email: "",
    phone: "",
    roles: [],
    permissions: [],
  });
  const [isEmailChanged, setIsEmailChanged] = useState(false);

  // const isUpdateMode = !!initialData; // Cek apakah ini update mode atau create mode

  //   const updateProfile = async (data) => {
  //     try {
  //       const result = await patchRequest("/me", data);
  //       return { success: true, data: result };
  //     } catch (err) {
  //       const errorResponse = {
  //         code: err.code || null,
  //         message: err.errors || "An error occurred",
  //       };
  //       return { success: false, errorResponse };
  //     }
  //   };

  // API hook untuk create dan update
  // const { createData: createProduct, loading: creatingProduct } = useCreateData(
  //   API_URL,
  //   "profile"
  // );
  const { updateData: updateProduct } = useUpdateData(
    `${API_URL}`,
    "profile"
  );

  const {
      handleSuccess,
      handleError,
    } = useCanvasHandler();

  const { handleSubmit } = useSubmitHandler(
    // isUpdateMode ? updateProduct : createProduct, gunakan update saja
    updateProduct,
    // onSuccess,
    // onError
    handleSuccess,
    handleError,
  );

  //   const { updateData: updateProduct, loading: updatingProduct } = useUpdateData(
  //     `${API_URL}/`,
  //     "me"
  //   );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

//   const { handleSuccess, handleError, showCanvasHandler } = useCanvasHandler();
  //   const { handleSubmit, isSubmitting, formError } = useSubmitHandler(
  //     updateProduct,
  //     handleSuccess,
  //     handleError,
  //     showCanvasHandler
  //   );

  useEffect(() => {
    if (user) {
      setFormData({
        id: user.id,
        name: user.name,
        email: user.email,
        phone: user.phone,
        roles: user.roles,
        permissions: user.permissions,
      });
    }
  }, [user]);

  // const handleBeforeSubmitVold = (e) => {
  //   e.preventDefault();
  //   const data = {
  //     name: formData.name,
  //     email: formData.email,
  //     phone: formData.phone,
  //   };

  //   handleSubmit(data, e);
  // };

  const handleBeforeSubmit = (e) => {
    e.preventDefault();
    const payload = {
      ...formData,
    };
    handleSubmit(payload, e);
  };

  if (loading) {
    return <FullLoader />;
  }

  return (
    <ProfileLayout>
      <form onSubmit={(e) => handleBeforeSubmit(e)}>
        <div className="card-body">
          <h2 className="mb-4">My Account</h2>
          <h3 className="card-title">Profile Details</h3>
          <div className="row align-items-center">
            <div className="col-auto">
              <span className="avatar avatar-xl">
                {user.name
                  ?.split(" ")
                  .map((word) => word[0])
                  .slice(0, 2)
                  .join("")
                  .toUpperCase()}
              </span>
            </div>
          </div>
          <h3 className="card-title mt-4">Account Profile</h3>
          <div className="row g-3">
            <div className="col-md">
              <label className="form-label">Account Name</label>
              <input
                type="text"
                className="form-control gotra-form-control"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter your full name"
              />
            </div>
            <div className="col-md">
              <label className="form-label">Phone</label>
              <input
                type="text"
                className="form-control gotra-form-control"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Enter your phone number"
              />
            </div>
          </div>
          <h3 className="card-title mt-4">Email</h3>
          <p className="card-subtitle">
            This contact will be shown to others publicly, so choose it
            carefully.
          </p>
          <div>
            <div className="row g-2">
              <div className="col-auto">
                <input
                  type="text"
                  className="form-control gotra-form-control w-auto"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  disabled={!isEmailChanged}
                  placeholder="Enter your email address"
                />
              </div>
              <div className="col-auto">
                <button
                  className="btn"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsEmailChanged((prev) => !prev);
                  }}
                >
                  Change
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="card-footer bg-transparent mt-auto">
          <div className="btn-list justify-content-end">
            <button className="btn btn-primary">Save</button>
          </div>
        </div>
      </form>
    </ProfileLayout>
  );
};

export default ProfilePage;
